import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from "@angular/router";
import { removeQueryParams } from "app/shared/components/select/helper-functions";
import { LobbyService } from "./lobby.service";
import { API_MAP } from "app/core/helpers/api.map";
import { map, tap } from "rxjs";

export const LobbyResolver: ResolveFn<boolean> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const router = inject(Router);
    return inject(LobbyService)
        .get(API_MAP.lobby + removeQueryParams(state.url).substring(1))
        .pipe(
            tap((d) => {
                if (!d.content) {
                    let params = state.root.children.find((r) => r.params?.['lang'])?.params;
                    router.navigate([(params?.['lang'] ?? 'he') + '/not-found']);
                }
            }),
            map(() => true)
        )
}